module.exports = __webpack_public_path__ + "static/media/sensa-white.a2a3af10.svg";